import { Children } from "react";
import Icon from "@web-ui/components/Icon";

export interface Crumb {
  label: string;
  href: string;
}

/**
 * The top of a page under the header's title (Polaris's page): breadcrumbs back up on a detail
 * page, and the page's one primary action at the end. Nothing renders when a page has neither.
 * `lead` puts a page's own controls at the start instead of crumbs (Home's range), on the same row.
 */
export function PageBar({ crumbs, lead, children }: { crumbs?: Crumb[]; lead?: React.ReactNode; children?: React.ReactNode }) {
  // Pages pass conditional actions ({canEdit ? <Button/> : null}); only real ones count.
  const actions = Children.toArray(children);
  if (!crumbs?.length && !lead && !actions.length) return null;
  return (
    <div className="flex min-h-12 flex-wrap items-center gap-3">
      {crumbs?.length ? (
        <nav aria-label="Breadcrumb" className="me-auto min-w-0">
          <ol className="flex flex-wrap items-center gap-1 text-body-2 text-t-secondary">
            {crumbs.map((c, i) => (
              <li key={`${i}:${c.label}`} className="flex items-center gap-1">
                {i > 0 ? <Icon name="chevron" size={4} className="-rotate-90 fill-t-tertiary rtl:rotate-90" /> : null}
                <a className="rounded-md transition-colors hover:text-t-primary focus-visible:outline-2 focus-visible:outline-s-focus" href={c.href}>{c.label}</a>
              </li>
            ))}
          </ol>
        </nav>
      ) : lead ? <div className="me-auto min-w-0">{lead}</div> : <span className="me-auto" />}
      {actions.length ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  );
}
